import { useState } from "react";
import SelectStaff from "components/elements/selectStaff";
import SelectShop from "components/elements/selectShop";
import DatetimePicker from "components/elements/dateTimePicker";
import { connect } from "react-redux";
import useCallApiUrl from "hook/useCallApiUrl";
import useCallSaleTrend from "./hooks/useCallSaleTrend";
import Loading from "components/Loading";
import { formatterCreateAt } from "components/Function";
import Map from "components/elements/analyticMapUs";
import TableState from "./tableState";
import ChartSaleTrend from "./chartSaleTrend";

const ShopAnalytic = () => {
    const [filter, setFilter] = useState({});
    const { data, loading } = useCallApiUrl("/api/analytic/shop-detail", filter, Object.keys(filter).length > 0);
    const { data: saleTrend, loading: loadingSaleTrendDate } = useCallSaleTrend(filter);
    const { data: saleTrendHours } = useCallSaleTrend(filter, "hour");
    const { data: saleTrendMonths } = useCallSaleTrend(filter, "month");
    const { data: saleTrendYears } = useCallSaleTrend(filter, "year");

    return (
        <div className="d-flex flex-column gap-6" style={{ maxWidth: "1780px", margin: "auto" }}>
            <Loading isLoading={loading || loadingSaleTrendDate} />
            <div className="d-flex gap-2 mb-4">
                <DatetimePicker
                    onChange={(data) => setFilter((prev) => ({ ...prev, ...data }))}
                    typeDefault="last_week"
                />
                <SelectStaff onChange={(data) => setFilter((prev) => ({ ...prev, staff: data }))} />
                <SelectShop onChange={(data) => setFilter((prev) => ({ ...prev, shopId: data }))} />
            </div>
            <div className="card card-body">
                <h3>Sales Trends By Date</h3>
                <ChartSaleTrend data={saleTrend?.data || []} />
            </div>
            <div className="card card-body">
                <h3>Sales Trends By Hour</h3>
                <ChartSaleTrend data={saleTrendHours?.data || []} type="Hour" />
            </div>
            <div className="card card-body">
                <h3>Sales Trends By Month</h3>
                <ChartSaleTrend data={saleTrendMonths?.data || []} type="Month" />
            </div>
            <div className="card card-body">
                <h3>Sales Trends By Year</h3>
                <ChartSaleTrend data={saleTrendYears?.data || []} type="Year" />
            </div>
            <div className="card card-body">
                <h3>Sales Trends By State</h3>
                <Map data={data?.orderState || []} />
                <TableState data={data?.orderState || []} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = { formatterCreateAt };

export default connect(mapStateToProps, mapDispatchToProps)(ShopAnalytic);
